import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import DisabilitySelectionViewModel from '../ViewModels/DisabilitySelectionViewModel';
import DisabilityViewModel from '../ViewModels/DisabilityViewModel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import DisabilitySelectionCard from './DisabilitySelectionCard';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IDisabilitySelectionProps {
    setDisabilitySelection: (model: DisabilitySelectionViewModel[]) => void;
    disabled: boolean;
}

interface IDisabilitySelectionState {
    selectedDisability: string | undefined;
    selectedDisabilityVal: number | undefined;
    disabilityList: DisabilityViewModel[];
    loaded: boolean;
    model: DisabilitySelectionViewModel[];

    displayAddButton: boolean;
}

class DisabilitySelection extends Component<IDisabilitySelectionProps & WithStyles<typeof styles>, IDisabilitySelectionState> {
    constructor(props) {
        super(props);
        this.state = {
            selectedDisability: undefined,
            selectedDisabilityVal: undefined,
            disabilityList: [],
            model: [],
            loaded: false,
            displayAddButton: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetDisabilitySelection').then(response => response.json()).then((data) => {
            this.setState({
                disabilityList: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.disabilityList.length > 0) {
            items.push(<MenuItem key="defaultDisabilitySelectionVal" value={undefined}></MenuItem>);
            items = this.state.disabilityList.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        let selectedItems: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            selectedItems = this.state.model.map(item =>
                <DisabilitySelectionCard disability={item} setPrimary={this.setPrimaryDisability} delete={this.deleteDisability} />
            );
        }

        return (
            <React.Fragment>
                <TextField
                    label="Please select Disability/Learning Difficulty"
                    name="learningDifficultyDropDown"
                    select
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    value={this.state.selectedDisability}
                    onChange={this.props.disabled ? undefined : this.setDisabilitySelection}
                    disabled={this.props.disabled}
                    InputProps={{
                        disabled: !this.state.loaded,
                        startAdornment: (
                            <React.Fragment>
                                {this.state.loaded ? null : <CircularProgress size={20} />}
                            </React.Fragment>
                        ),
                        endAdornment:
                           
                            <InputAdornment position="end">
                                {this.state.displayAddButton && 
                                <Button onClick={this.addDisability} color="primary" variant="contained" fullWidth endIcon={<AddIcon />}>
                                    Add Disability
                            </Button>}
                        </InputAdornment>,
                        readOnly: this.props.disabled
                    }}
                >
                    {items}
                </TextField>
                {selectedItems}
            </React.Fragment>
        );
    }

    public setDisabilitySelection = (event) => {
        console.log(event.target);
        if (this.state.selectedDisability !== event.target.value) {
            this.setState({
                selectedDisability: this.state.disabilityList.filter(dis => dis.value === event.target.value)[0].display,
                selectedDisabilityVal: event.target.value,
                displayAddButton: true
            }, () => { console.log(this.state) });
        }
    }

    public addDisability = (event) => {
        let newModel = this.state.model;
        
        if (!newModel.filter(disability => disability.disabilityId === this.state.selectedDisabilityVal).length) {
            if (this.state.selectedDisability !== undefined && this.state.selectedDisabilityVal !== undefined) {
                let disViewModel: DisabilitySelectionViewModel = new DisabilitySelectionViewModel();
                disViewModel.disabilityDisplay = this.state.selectedDisability;
                disViewModel.disabilityId = this.state.selectedDisabilityVal;
                if (this.state.model.length > 0) {
                    disViewModel.isPrimary = false;
                } else {
                    disViewModel.isPrimary = true;
                }
                newModel.push(disViewModel);
                
                this.setState({ model: newModel, displayAddButton: false }, () => { this.props.setDisabilitySelection(newModel) });
            }
        }
    }

    public setPrimaryDisability = (id: number) => {
        let newModel = this.state.model;
        newModel.forEach((item) => {
            if (item.disabilityId == id) {
                item.isPrimary = true;
            } else {
                item.isPrimary = false;
            }
        });     

        this.setState({ model: newModel });
    }
    public deleteDisability = (id: number) => {
        let newModel = this.state.model;
        newModel = newModel.filter(dis => dis.disabilityId !== id);

        this.setState({ model: newModel });
    }
}

export default withStyles(styles)(DisabilitySelection);